import React, { useEffect, useRef } from "react";

/**
 * Portal success/error banner that auto-dismisses after `durationMs` (default 10s).
 */
function PortalAlert({ type = "error", message, onClear, durationMs = 10000 }) {
  const text = typeof message === "string" ? message.trim() : "";
  const onClearRef = useRef(onClear);
  onClearRef.current = onClear;

  useEffect(() => {
    if (!text) return undefined;
    const timer = setTimeout(() => {
      if (typeof onClearRef.current === "function") onClearRef.current();
    }, durationMs);
    return () => clearTimeout(timer);
  }, [text, durationMs]);

  if (!text) return null;

  const tone = type === "success" ? "success" : "error";
  return <div className={`cportal-alert cportal-alert-${tone}`}>{text}</div>;
}

export default PortalAlert;
